// Ajaxing SVG sprite

import WebComponent from 'fg-frontend/src/webComponents/WebComponent';

export default class GoBack extends WebComponent {
  constructor(props) {
    super(props);
    this.handleGoBack = this.handleGoBack.bind(this);
  }
  didMount() {
    this.element.addEventListener('click', this.handleGoBack)
  }
  handleGoBack(e) {
    e.preventDefault();
    // console.log(window.projectConfig.lang);
    if (document.referrer == '' || window.history.length === 1) {
      switch (window.projectConfig.lang) {
        case 'cs':
          window.location.href = '/cs';
          break;
        case 'en':
          window.location.href = '/en';
          break;
        case 'de':
          window.location.href = '/de';
          break;
        default:
          window.location.href = '/en'; // Fallback to English
      }
    } else {
      window.history.back();
    }
  }
}



// WEBPACK FOOTER //
// ./fe/web-default/src/js/components/GoBack.js